import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../utils/axiosconfig';
import './register.css';

const RegisterSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  contact_number: Yup.string()
    .matches(/^\d{10}$/, 'Contact number must be 10 digits')
    .required('Contact number is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 8 characters')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});

const RegisterComponent = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await api.post('/auth/signup', {
        email: values.email,
        first_name: values.first_name,
        last_name: values.last_name,
        contact_number: values.contact_number,
        password: values.password
      });
      toast.success('Registration successful! Please log in.');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred during registration');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="section-account parallax bg-11">
      <div className="awe-overlay"></div>
      <div className="container">
        <div className="login-register">
          <div className="text text-center">
            <h2>REGISTER ACCOUNT</h2>
            <div className="register-box">
              <Formik
                initialValues={{
                  email: '',
                  first_name: '',
                  last_name: '',
                  contact_number: '',
                  password: '',
                  confirmPassword: ''
                }}
                validationSchema={RegisterSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form className="account_form">
                    <div className="field-form">
                      <Field
                        type="email"
                        name="email"
                        className={`field-text ${errors.email && touched.email ? 'is-invalid' : ''}`}
                        placeholder="Email"
                      />
                      {errors.email && touched.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                    <div className="field-form">
                      <Field
                        type="text"
                        name="first_name"
                        className={`field-text ${errors.first_name && touched.first_name ? 'is-invalid' : ''}`}
                        placeholder="First Name"
                      />
                      {errors.first_name && touched.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
                    </div>
                    <div className="field-form">
                      <Field
                        type="text"
                        name="last_name"
                        className={`field-text ${errors.last_name && touched.last_name ? 'is-invalid' : ''}`}
                        placeholder="Last Name"
                      />
                      {errors.last_name && touched.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
                    </div>
                    <div className="field-form">
                      <Field
                        type="tel"
                        name="contact_number"
                        className={`field-text ${errors.contact_number && touched.contact_number ? 'is-invalid' : ''}`}
                        placeholder="Contact Number"
                      />
                      {errors.contact_number && touched.contact_number && <div className="invalid-feedback">{errors.contact_number}</div>}
                    </div>
                    <div className="field-form">
                      <div className="password-input-wrapper">
                        <Field
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className={`field-text ${errors.password && touched.password ? 'is-invalid' : ''}`}
                          placeholder="Password"
                        />
                        <span
                          className="view-pass"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                        </span>
                      </div>
                      {errors.password && touched.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>
                    <div className="field-form">
                      <Field
                        type={showPassword ? "text" : "password"}
                        name="confirmPassword"
                        className={`field-text ${errors.confirmPassword && touched.confirmPassword ? 'is-invalid' : ''}`}
                        placeholder="Confirm Password"
                      />
                      {errors.confirmPassword && touched.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
                    </div>
                    <div className="field-form field-submit">
                      <button type="submit" className="awe-btn awe-btn-13" disabled={isSubmitting}>
                        {isSubmitting ? 'REGISTERING...' : 'REGISTER'}
                      </button>
                    </div>
                    <div className="account-desc">
                      <a href="/login">I already have an account</a>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterComponent;